export const getClassement = (classement) => {
  if (classement.toString().includes(" - ")) {
    return parseInt(classement.split("- ").at(-1), 10);
  }
  return classement;
};
